import { render, staticRenderFns } from "./Diagram.vue?vue&type=template&id=3bcf5d5c&scoped=true&"
import script from "./Diagram.vue?vue&type=script&lang=js&"
export * from "./Diagram.vue?vue&type=script&lang=js&"
import style0 from "./Diagram.vue?vue&type=style&index=0&id=3bcf5d5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcf5d5c",
  null
  
)

export default component.exports